import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/noVisitAfterFirstVisitSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import TimePeriod from "./smartComponents/TimePeriod";
import DatePicker from "./smartComponents/DatePicker";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import NoVisitAfterFirstVisitChart from "./smartComponents/NoVisitAfterFirstVisitChart";
import CustomFilters from "./smartComponents/CustomFilters";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const NoVisitAfterFirstVisitModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.noVisitAfterFirstVisit.isLoading);
  const initialRequest = useSelector((state) => state.noVisitAfterFirstVisit.initialRequest);
  const updatesLoading = useSelector((state) => state.noVisitAfterFirstVisit.updatesLoading);

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <CustomFilters />
            </div>
            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Time</p>
                <TimePeriod />
              </div>
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box select-box-no-width monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              <UpdateButtons />
            </div>
          </div>
        </div>
        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <NoVisitAfterFirstVisitChart />
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="module-date-filters">
      <SectionToggle
        autoHeight
        height={690}
        title="No Visit After First Visit"
        isLoading={isLoading}
        content={content()}
        learnMore={
          <KBLearnMore
            title="No Visit After First Visit"
            description="This report shows clients who completed a first visit but did not return within your selected timeframe. These insights help you identify drop-off points, highlight members who may need targeted outreach, and improve early engagement."
            kbUrl={ILEARN_URLS.retention.noVisitAfterFirstVisit}
          />
        }
      />
    </div>
  );
};

NoVisitAfterFirstVisitModule.propTypes = {
  params: PropTypes.object
};

export default React.memo(NoVisitAfterFirstVisitModule);
